import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import { useOverlayContext } from 'seagull';
import ServiceBuilder from '~/components/ServiceBuilder/ServiceBuilder';
import { useServiceTemplates } from '~/hooks/reactQuery/queries/useServiceTemplates';
import { useServiceTemplateApi } from '~/hooks/useServiceTemplateApi';
import { useLocaleKeys } from '~/i18n';
import { makeFailure, makeSuccess } from '~/infra/utils';
import { serviceTemplateModel } from '~/models';
import { AgreementDataModel } from '~/models/AgreementDataModel';
import { ServiceTemplateType } from '~/models/service-template';
const EMPTY_SERVICE_TEMPLATES = [];
export const useCreateServiceTemplateForBill = (param)=>{
    let { relationship } = param;
    var _ref;
    const serviceTemplateApi = useServiceTemplateApi();
    const { showModal, showSuccessToast, showErrorToast } = useOverlayContext();
    const { t: commonTexts } = useLocaleKeys('common');
    const { data, refresh: refreshServiceTemplates } = useServiceTemplates(ServiceTemplateType.Service);
    const serviceTemplates = (_ref = data === null || data === void 0 ? void 0 : data.active) !== null && _ref !== void 0 ? _ref : EMPTY_SERVICE_TEMPLATES;
    const openCreateServiceTemplate = async ()=>{
        let createdTemplate;
        const onSave = async (service)=>{
            const body = serviceTemplateModel.fromService(service);
            try {
                const { id } = await serviceTemplateApi.create(body);
                createdTemplate = serviceTemplateModel.setId(body, id);
            } catch (error) {
                showErrorToast(commonTexts.toasts.failedToCreateService(), 'bill-service-creation-failed');
                return makeFailure(error);
            }
            showSuccessToast(commonTexts.toasts.serviceCreatedSuccessfully(), 'bill-service-created-success');
            await refreshServiceTemplates({
                throwOnError: false
            });
            return makeSuccess({
                id: createdTemplate.id
            });
        };
        await showModal({
            biName: 'service_builder_modal',
            transparentBackdrop: true,
            content: (modalProps)=>/*#__PURE__*/ _jsx(ServiceBuilder, _object_spread_props(_object_spread({}, modalProps), {
                    serviceNameBlacklist: serviceTemplates.map((template)=>template.name),
                    agreementData: AgreementDataModel.fromRelationship(relationship),
                    serviceOrigin: "template",
                    onSave: onSave
                }))
        });
        return createdTemplate;
    };
    return {
        openCreateServiceTemplate
    };
};
